module.exports = __webpack_public_path__ + "img/loading.07f010bd.gif";